import { playerState } from "../state/stateManager";

export default function getNPCContent() {
  let player = playerState.getPlayer();
  return {
    grandpa: {
      firstIntro: [
        `My goodness! ${player.name}. I never thought you'd actually accept my offer!`,
        `I can't believe you're here! Oh, kiddo, you made this old man very, very happy.`,
        `Come, let's chat in the house!`,
      ],
      houseIntro: [
        `I'm so glad to have you here. BoBees is in trouble and I can't think of anyone I would rather have help me bring it back.`,
        `It's those damned mites ${player.name}, they build up in the hives, sucking the lifeblood and spreading disease!`,
        `The mites came to this area 30 years ago, we didn't know what to think!`,
        `They aren't like other parasites, our bees don't seem to have much of a defense for them!`,
        `So, our great Bobees dwindled over time, succumbing to those friggin' bastard mites!`,
        `UGH! Just talking about those damned things makes me livid.`,
        `So please, ${player.name}, help me rebuild BoBees. We only have $2000, but I'm sure you can figure out a way to rebuild.`,
        `For questions regarding inspections, splits, honey production and sales, come to me! I have decades of experience and am eager to teach!`,
        `For questions about mites, go to the bee club in town. There are a lot of helpful, knowledgeable people there.`,
        `To purchase items, either use the computer in your room, or head to town. To access the inventory, go to the honey shed. To add hives or interact with items, use the SPACE bar.`,
        `Alright, you had better get out there and check on those bees!`,
      ],
    },
    katie: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Awwwhh thank you. I'm flattered`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Ugh, No thanks.`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Hi there, welcome to McCarty's, my name is Katie.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: -5, shouldShow: "upset" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Well don't you look nice"`,
          ],
        },
        secondQuestion: {
          question: `You must be related to Bo! We love him around here. I hope we get the opportunity to start buying honey from you guys again.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "Thank you, that's exactly what I'm here for!"`,
            `Reply: "I'm looking to sell some honey."`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `Ugh not you again?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: -3, shouldShow: null },
            },
            replies: [
              `Reply: "Yep, could I sell you guys some honey today?"`,
              `Reply: "I'd love to take you out some time."`,
            ],
          },
          {
            question: `What?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'm great, and how have you been?"`,
              `Reply: "Hi, can I sell you guys some honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi again, looking to sell some honey?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: null },
              2: { relationshipBump: -3, shouldShow: "upset" },
            },
            replies: [
              `Reply: "Yep, how much do you guys need?"`,
              `Reply: "Ahh, I wish, maybe in a few weeks"`,
              `Reply: "I'd love to take you out some time."`,
            ],
          },
          {
            question: `Well how the hell are ya? Selling honey today?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: -1, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'm great, and how have you been?"`,
              `Reply: "Hi, can I sell you guys some sweet stuff?"`,
            ],
          },
          {
            question: `Sup?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "Hi, can I sell you guys some honey?"`,
              `Reply: "How's everything been?"`,
            ],
          },
          {
            question: `Well if it isn't ${player.name}, what's going on?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Not much, how ya been?"`,
              `Reply: "Hi, out of honey yet?"`,
            ],
          },
          {
            question: `Back again? What an I do for ya?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi, can I sell you guys some honey?"`,

              `Reply: "Just came in to see a smiling face."`,
            ],
          },
        ],
        midLevel: [
          {
            question: `Hey, ${player.name}, you've been on my mind lately. What's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "Hi Katie! Any chance I could sell some honey?"`,
              `Reply: "Awwhh shucks, I've been thinking about you too."`,
            ],
          },
          {
            question: `After the day I've had I'm glad it's just you`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 2, shouldShow: null },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "Awwhh what's wrong?"`,
            ],
          },
          {
            question: `Well holy *#$* I was just thinking about you?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I was just thinking about you too!"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `Oh I was just saying I hoped you'd stop by!`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "A day is not a day without a little time with you"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
          {
            question: `${player.name}! I'm so glad to see you. What's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'm glad to see you too Katie!"`,
            ],
          },
          {
            question: `${player.name} it's always a delight when you walk through the door, what's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "You always put a smile on my face."`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
      },
    },
    colin: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Awwwhh thank you. I'm flattered`,
          shouldShow: null,
          replies: [],
        },
        sellHoney: {
          question: `How much honey would you like to sell? We have space for 12 jars`,
          shouldShow: null,
          replies: [],
        },
        standardQuestion: {
          question: `Hi there, ${player.name}, what can I do for you today?`,
          relationship: {
            0: { relationshipBump: 0, shouldShow: "sellHoney" },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
            2: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "I'm looking to sell some honey."`,
            `Reply: "I'd like to buy some sugar."`,
            `Reply: "Ahh, nothing, I'm just browsing."`,
          ],
        },
        firstQuestion: {
          question: `Hellloooooo newcomer. Welcome to the Kozmania Farmer's Market, My name is Colin. What are you here for? Spices, Herbs, or something more fancy?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 3, shouldShow: "secondFancyQuestion" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Something more fancy"`,
          ],
        },
        secondQuestion: {
          question: `Ahh, the old BoBees farm! You must be Bo's granson. I do hope to see you guys rebuild. Kozmania is better off with lots of Bobees honey!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
            2: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "Thank you, that's exactly what I'm here for!"`,
            `Reply: "I'm looking to sell some honey."`,
            `Reply: "I'd like to buy some sugar."`,
          ],
        },
        secondFancyQuestion: {
          question: `Well we'd have to get to know each other first.`,
          relationship: {
            0: { relationshipBump: 2, shouldShow: "secondQuestion" },
            1: { relationshipBump: 3, shouldShow: "flattered" },
            2: { relationshipBump: -3, shouldShow: null },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Well we'll have to work on that then."`,
            `Reply: "Uhh, sure."`,
          ],
        },
      },
      randomQuestions: {
        lowLevel: [
          {
            question: `Hello sir, looking to sell some honey?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: null },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Yep, have any shelf space?"`,
              `Reply: "Ahh, I wish, maybe in a few weeks"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `Some days it's nice to see a smiling face. What's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Always nice to see you, Colin."`,
              `Reply: "Hi, any shelf space for honey?"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `Hi there`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi, any shelf space for honey?"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `Well aren't you lookin' fine today. What can I do for ya?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Well thank you! You aren't lookin' bad yourself."`,
              `Reply: "Hi, any shelf space for honey?"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `Welcome to the KFM, what's up today?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi, any shelf space for honey?"`,

              `Reply: "I'd like to buy some sugar"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `My brother from another mother, what's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Colin! Any shelf space for honey?"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `You're a sight for sore eyes. What can I do you for?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `Well holy *#$* I was just thinking about you?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I was just thinking about you too!"`,
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `My favorite sonofabee, How are ya?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Great! How are you?"`,
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `You're a sight for sore eyes. What can I do you for?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
          {
            question: `${player.name} it's always a delight when you walk through the door, what's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "You always put a smile on my face."`,
              `Reply: "I'd like to sell some honey"`,
              `Reply: "I'd like to buy some sugar"`,
            ],
          },
        ],
      },
    },
    margie: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Well aren't you sweet. Cute too!`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          shouldShow: null,
          replies: [],
        },

        good: {
          question: `I'm good! Thank you!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Oh don't do me like that. Not today!`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `A newcomer to Kozmania, and he's cute?! Who are you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: -1, shouldShow: "upset" },
          },
          replies: [
            `Reply: "Oh thank you! My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Nobody"`,
          ],
        },
        secondQuestion: {
          question: `Oh boy, I love my mead, and biscuits aren't complete without some fresh honey!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "drink" },
            1: { relationshipBump: 2, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "Oh you like to drink mead?"`,
            `Reply: "Would you like a free jar of honey?"`,
          ],
        },
        drink: {
          question: `I drink it every day! It calms the crazy and keeps me young!`,
          relationship: {
            0: { relationshipBump: 2, shouldShow: "thanks" },
            1: { relationshipBump: 2, shouldShow: "sellHoney" },
            2: { relationshipBump: -1, shouldShow: null },
          },
          replies: [
            `Reply: "I can see that it does!"`,
            `Reply: "Would you like a free jar of honey?"`,
            `Reply: "Uhuh."`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `Oh you had better get out of my way before I take my sandal to ya!`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sorry, have a good day."`,
              `Reply: "What?"`,
              `Reply: "Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi there. I haven't started drinkin' yet so make it short.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Margie, how are you?"`,
              `Reply: "Hi Margie, can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `${player.name} you are lookin' fine today.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [
              `Reply: "Oh thank you, Margie. You aren't looking too bad yourself!"`,
              `Reply: "Thank you!"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name} how are you doin, sweet thang?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "good" },
              1: { relationshipBump: 3, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Good, Margie, how are you?!"`,
              `Reply: "Great, Margie, would you like a free jar of BoBees honey?"`,
            ],
          },
        ],
      },
    },
    liv: {},
    sparky: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Awwwhhh shucks. Yer' just bein' kind.`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Gggrrrmmpph. Who are you? What's Your Story?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 3, shouldShow: "secondSadQuestion" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "I'm ${player.name}. My life hasn't been what I'd hoped it would be, if I'm being honest."`,
          ],
        },
        secondQuestion: {
          question: `Ahh yes, Bo's Daughter's Kid. Well, if you're related to Bo, you're good in my book.`,
          shouldShow: null,
          replies: [],
        },
        secondSadQuestion: {
          question: `Well, kid, that's life. But you have to keep trying, yknow?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
          },
          replies: [`Reply: "Yeah, thank you."`],
        },
        firstBusiness: {
          question: `We do buy a lot of honey, our fish seems to always go down better with some mead. I won't pay more than Furdland prices though.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "sellHoney" },
            1: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "No problem, I'm just looking to get rid of an abundance!"`,
            `Reply: "Thanks but no thanks."`,
          ],
        },
        secondBusiness: {
          question: `I tell you what, I wouldn't be against the idea of finding a new supplier for all of my stores. Let me know when you have 1000 jars and 20 or more hives.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 3, shouldShow: null },
          },
          replies: [`Reply: "Thank you so much, I will!"`, `Reply: "Will do."`],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `Ugh not you again?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: -3, shouldShow: null },
            },
            replies: [
              `Reply: "Yep, could I sell you guys some honey today?"`,
              `Reply: "I'd love to take you out some time."`,
            ],
          },
          {
            question: `What?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'm great, and how have you been?"`,
              `Reply: "Hi, can I sell you guys some honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi again, looking to sell some honey?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [
              `Reply: "Yep, how much do you guys need?"`,
              `Reply: "Ahh, I wish, maybe in a few weeks"`,
            ],
          },
          {
            question: `Well how the hell are ya? Selling honey today?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: -1, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'm great, and how have you been?"`,
              `Reply: "Yes I am! Fresh from the bee yard."`,
            ],
          },
          {
            question: `Sup?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "Hi, can I sell you guys some honey?"`,
              `Reply: "The fish been biting?"`,
            ],
          },
          {
            question: `Well if it isn't ${player.name}, how ya be?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Not much, how ya been?"`,
              `Reply: "Hi, out of honey yet?"`,
            ],
          },
          {
            question: `Yarr?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [`Reply: "Hi, can I sell you guys some honey?"`],
          },
        ],
        midLevel: [
          {
            question: `Hey, ${player.name}, still chasin stingers?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "Yep, and looking to sell honey!"`,
              `Reply: "You know it."`,
            ],
          },
          {
            question: `Back in the day, yer grandpa and I would raise hell 'round here.`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 2, shouldShow: null },
            },
            replies: [
              `Reply: "Can I sell you some honey?"`,
              `Reply: "Haha, I'm sure you did!"`,
            ],
          },
          {
            question: `I swear to god I would lose me head if it wern't attached. What's up?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "You're doin' great, Sparky."`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `If it arnt my favorite proprietor of insect secretions.`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Thanks, Sparky, that's high praise."`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
          {
            question: `${player.name}! How the hell er ya?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 3, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Pretty good, Sparky, pretty good."`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
          {
            question: `${player.name} ya sonofa, what's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sparky! My favorite sonofa"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
      },
    },
    bigBen: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Thankya!`,
          shouldShow: null,
          replies: [],
        },
        sellHoney: {
          question: `How much honey would you like to sell? We have space for 12 jars`,
          shouldShow: null,
          replies: [],
        },
        standardQuestion: {
          question: `Hi there, ${player.name}, what can I do for you today?`,
          relationship: {
            0: { relationshipBump: 0, shouldShow: "sellHoney" },
            2: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "I'm looking to sell some honey."`,
            `Reply: "Ahh, nothing, I'm just browsing."`,
          ],
        },
        firstQuestion: {
          question: `Hi there! I don't believe I've ever met you, my name is Big Ben. Who're you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 3, shouldShow: "secondFancyQuestion" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Big ${player.name}!"`,
          ],
        },
        secondQuestion: {
          question: `A beekeeper! Well we buy a lot of honey for our signature line of Meads. Come around when you get more than 100 jars!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "I will!"`,
            `Reply: "I'm looking to sell some honey."`,
          ],
        },
        secondFancyQuestion: {
          question: `Heck yeah man!`,
          shouldShow: null,

          replies: [],
        },
      },
      randomQuestions: {
        lowLevel: [
          {
            question: `Hello sir, looking to sell some honey?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [
              `Reply: "Yep, you guys need any?"`,
              `Reply: "Ahh, I wish, maybe in a few weeks"`,
            ],
          },
          {
            question: `Some days it's nice to see a smiling face. What's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Always nice to see you, Big Ben."`,
              `Reply: "Hi, any shelf space for honey?"`,
            ],
          },
          {
            question: `Hi there`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 1, shouldShow: null },
            },
            replies: [
              `Reply: "Hi, any shelf space for honey?"`,
              `Reply: "Hi there!"`,
            ],
          },
          {
            question: `${player.name} whatchya got for me today?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Ahh not much."`,
              `Reply: "You know what! I got that honey!"`,
            ],
          },
          {
            question: `Welcome to the Big Ben's, what's up today?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 1, shouldShow: null },
            },
            replies: [
              `Reply: "Hi, any shelf space for honey?"`,

              `Reply: "Hi Big Ben."`,
            ],
          },
        ],
        midLevel: [
          {
            question: `My brother from another mother, what's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 1, shouldShow: null },
            },
            replies: [
              `Reply: "Hi Big Ben! Need any honey?"`,
              `Reply: "Not much brother."`,
            ],
          },
          {
            question: `You're a sight for sore eyes. What can I do you for?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "Not much today, thanks though."`,
            ],
          },
          {
            question: `Well holy *#$* I was just thinking about you?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I was just thinking about you too!"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `My favorite sonofabee, How are ya?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Great! How are you?"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
          {
            question: `You're a sight for sore eyes. What can I do you for?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 1, shouldShow: null },
            },
            replies: [
              `Reply: "I'd like to sell some honey"`,
              `Reply: "Thanks man!"`,
            ],
          },
          {
            question: `${player.name} it's always a delight when you walk through the door, what's up?`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Big Ben! How the heck are ya?!"`,
              `Reply: "I'd like to sell some honey"`,
            ],
          },
        ],
      },
    },
    hippyChick: {},
    linda: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Well aren't you sweet.`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Ugh, No thanks.`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          relationship: {
            0: { relationshipBump: 3, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "You're very welcome!"`,
            `Reply: "If you like it, tell your friends!"`,
          ],
        },
        firstQuestion: {
          question: `Well it ain't too often I see a new face around here. Who are you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 5, shouldShow: "flattered" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Well don't you look nice"`,
          ],
        },
        secondQuestion: {
          question: `Oh boy, so you're a beekeeper? We do love honey around here! Well, my name is Linda, it was very nice to meet you.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "Nice to meet you too!"`,
            `Reply: "Would you like a jar of honey?"`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `Does it smell funny around here all of a sudden?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -3, shouldShow: null },
            },
            replies: [
              `Reply: "I don't think so."`,
              `Reply: "I'd love to take you out some time."`,
            ],
          },
          {
            question: `Huh?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I'm great, and how have you been?"`,
              `Reply: "Hi, would you like a free jar of BoBees Honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -1, shouldShow: null },
              2: { relationshipBump: -3, shouldShow: "upset" },
            },
            replies: [
              `Reply: "Hi there"`,
              `Reply: "Sup?"`,
              `Reply: "I'd love to take you out some time."`,
            ],
          },
          {
            question: `Hi there!`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 2, shouldShow: "flattered" },
              2: { relationshipBump: -1, shouldShow: "upset" },
            },
            replies: [
              `Reply: "Hi Linda, how's everything been?"`,
              `Reply: "You look beautiful today Linda"`,
              `Reply: "Hey sweet thang."`,
            ],
          },
          {
            question: `Well if it isn't ${player.name}, what's going on?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Not much, how ya been?"`,
              `Reply: "Hi, can I interest you in a free jar of BoBees Honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `Hey, ${player.name}, you've been on my mind lately. What's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: null },
              1: { relationshipBump: 3, shouldShow: "flattered" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Linda! How's life?"`,
              `Reply: "Awwhh shucks, I've been thinking about you too."`,
              `Reply: "I was wondering if you wanted a free jar of BoBees honey?"`,
            ],
          },
          {
            question: `What's goin' on?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: null },
            },
            replies: [
              `Reply: "Not much Linda, how ya been?"`,
              `Reply: "Well don't you look nice."`,
            ],
          },
          {
            question: `Well holy *#$* I was just thinking about you?`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 1, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "I was just thinking about you too!"`,
              `Reply: "I'm honored! Interested in some free BoBees Honey?"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name}! How are you! I have missed you!`,
            relationship: {
              0: { relationshipBump: 3, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "A day is not a day without a little time with you"`,
              `Reply: "Interested in some free BoBees Honey?"`,
            ],
          },
          {
            question: `${player.name}! I'm so glad to see you. What's up?`,
            relationship: {
              0: { relationshipBump: 0, shouldShow: "sellHoney" },
              1: { relationshipBump: 3, shouldShow: null },
            },
            replies: [
              `Reply: "I'm just lookin to give a pretty girl a free jar of BoBees Honey"`,
              `Reply: "I'm glad to see you too Linda!"`,
            ],
          },
        ],
      },
    },
    ronald: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Well thanks!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Grmmph`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          relationship: {
            0: { relationshipBump: 3, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "You're very welcome!"`,
            `Reply: "If you like it, tell your friends!"`,
          ],
        },
        firstQuestion: {
          question: `What's up big fella? Who are you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 0, shouldShow: "upset" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Just some guy"`,
          ],
        },
        secondQuestion: {
          question: `Ahh, makin honey and makin MEAD, I'd hope.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "You bet!"`,
            `Reply: "Would you like a jar of honey?"`,
          ],
        },
      },
      townQuestions: {
        reallyLow: [
          {
            question: `Move! I'm going to the watering hole!`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
            },
            replies: [`Reply: "Sorry, have a good day."`, `Reply: "Move?"`],
          },
        ],
        lowLevel: [
          {
            question: `Is it time to imbibe yet?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [`Reply: "Definitely!"`, `Reply: "I'm not sure."`],
          },
        ],
        midLevel: [
          {
            question: `${player.name} I'd love to chat but there's a mug with my name on it at McCarty's`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: 0, shouldShow: null },
            },
            replies: [`Reply: "Bottoms up!"`, `Reply: "Go ahead."`],
          },
        ],
        highLevel: [
          {
            question: `If it isn't my favorite purveyor of mead ingredients.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "If it isn't my favorite mead consumer!"`,
              `Reply: "Would you like a free jar of BoBees honey?"`,
            ],
          },
        ],
      },
      mccartysQuestions: {
        reallyLow: [],
        lowLevel: [],
        midLevel: [],
        highLevel: [],
      },
      sparkysQuestions: {
        reallyLow: [],
        lowLevel: [],
        midLevel: [],
        highLevel: [],
      },
    },
    marvin: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Thank you!`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          relationship: {
            0: { relationshipBump: 3, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: null },
          },
          replies: [
            `Reply: "You're very welcome!"`,
            `Reply: "If you like it, tell your friends!"`,
          ],
        },
        buyBoxes: {
          question: `That depends on how many you buy, come to my house when you need some and we'll make a deal!`,
          shouldShow: null,
          replies: [],
        },
        good: {
          question: `I'm good! Thank you!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Huh?`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Well Hi there! Who are you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 0, shouldShow: "upset" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Nobody"`,
          ],
        },
        secondQuestion: {
          question: `A Beek! Well if you end up needing more boxes you should let me know. My family and I make bee boxes for less than Furdland!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
            2: { relationshipBump: 0, shouldShow: "buyBoxes" },
          },
          replies: [
            `Reply: "I will, thank you!"`,
            `Reply: "Would you like a jar of honey?"`,
            `Reply: "How much for your bee boxes?"`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `What?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sorry, have a good day."`,
              `Reply: "What?"`,
              `Reply: "Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi there.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "buyBoxes" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Marvin, how are you?"`,
              `Reply: "Hi. Have any boxes for sale?"`,
              `Reply: "Hi Marvin, can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `${player.name} how are you, good sir?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "buyBoxes" },
            },
            replies: [
              `Reply: "Very good. How are you, Marvin?"`,
              `Reply: "Good! Can I interest you in a free jar of BoBees honey?"`,
              `Reply: "Good! Have any boxes for sale?"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name} I hope life is treating you well.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
              2: { relationshipBump: 0, shouldShow: "buyBoxes" },
            },
            replies: [
              `Reply: "It is. I hope you are well, Marvin."`,
              `Reply: "Would you like a free jar of BoBees honey?"`,
              `Reply: "It is! Do you have any bee boxes for sale?`,
            ],
          },
        ],
      },
    },

    bill: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Thank you!`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          shouldShow: null,
          replies: [],
        },

        good: {
          question: `I'm good! Thank you!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Who the heck are you talking to?`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Howdy! A new face! Who're you?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: -1, shouldShow: "upset" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Nobody"`,
          ],
        },
        secondQuestion: {
          question: `I used to keep bees too! I tell ya, I don't miss the stings, but I do miss the honey!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "I'm pretty geeked about the honey too."`,
            `Reply: "Would you like a free jar of honey?"`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `What?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sorry, have a good day."`,
              `Reply: "What?"`,
              `Reply: "Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi there.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Bill, how are you?"`,
              `Reply: "Hi Bill, can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `${player.name} how are you, good sir?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Very good. How are you, Bill?"`,
              `Reply: "Good! Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name} I hope life is treating you well.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "It is. I hope you are well, Bill."`,
              `Reply: "Would you like a free jar of BoBees honey?"`,
            ],
          },
        ],
      },
    },
    kevin: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `My My. Thank you.`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Much obliged.",
          shouldShow: null,
          replies: [],
        },

        good: {
          question: `I'm good! Thank you!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `You wanna get jammed up?`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Greetings! Are you new around here?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: -1, shouldShow: "upset" },
          },
          replies: [
            `Reply: "Yes! My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "No"`,
          ],
        },
        secondQuestion: {
          question: `Ahh, a beekeeper! I'm quite active with the bee community, I am the Bee Club's attorney and treasurer!`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "invite" },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "Oh wow, I wonder if I could ever get involved over there?."`,
            `Reply: "Would you like a free jar of honey?"`,
          ],
        },
        invite: {
          question: `I might have a task or two for you. The Bee Club is experiencing some difficulties that you might be able to assist with. Come to my office so we can chat.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: null },
            1: { relationshipBump: 0, shouldShow: null },
          },
          replies: [`Reply: "I will, thank you!"`, `Reply: "Uhuh."`],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `Hmmm?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sorry, have a good day."`,
              `Reply: "What?"`,
              `Reply: "Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi there.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              2: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Kevin, how are you?"`,
              `Reply: "Hi Kevin, can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `${player.name} how are you, good sir?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Very good. How are you, Kevin?"`,
              `Reply: "Good! Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name} I hope life is treating you well.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "It is. I hope you are well, Kevin."`,
              `Reply: "Would you like a free jar of BoBees honey?"`,
            ],
          },
        ],
      },
    },
    jackson: {
      shouldShow: null,
      questions: {
        flattered: {
          question: `Thank you!`,
          shouldShow: null,
          replies: [],
        },
        thanks: {
          question: "Thank you so much!",
          shouldShow: null,
          replies: [],
        },
        iWill: {
          question:
            "I will let you know when I need the hives placed for my garden.",
          shouldShow: null,
          replies: [],
        },
        good: {
          question: `I'm good! Thank you!`,
          shouldShow: null,
          replies: [],
        },
        agree: {
          question: `Ahh, aren't we all?!`,
          shouldShow: null,
          replies: [],
        },
        upset: {
          question: `Who the heck are you talking to?`,
          shouldShow: null,
          replies: [],
        },
        firstQuestion: {
          question: `Well I'll be. I haven't seen a new face around here in a dog's age. What's your story, friend?`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "secondQuestion" },
            1: { relationshipBump: 0, shouldShow: "agree" },
          },
          replies: [
            `Reply: "My name is ${player.name}, I live at the honey farm up the road"`,
            `Reply: "Just a guy, trying to get ahead"`,
          ],
        },
        secondQuestion: {
          question: `A beekeeper! Nice, very nice, I may have a need to hire some pollination hives next year.`,
          relationship: {
            0: { relationshipBump: 1, shouldShow: "iWill" },
            1: { relationshipBump: 0, shouldShow: "sellHoney" },
          },
          replies: [
            `Reply: "I'd take your pollination contract! Let me know!"`,
            `Reply: "Would you like a free jar of honey?"`,
          ],
        },
      },
      randomQuestions: {
        reallyLow: [
          {
            question: `What?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: null },
              1: { relationshipBump: -2, shouldShow: "upset" },
              2: { relationshipBump: 2, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Sorry, have a good day."`,
              `Reply: "What?"`,
              `Reply: "Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        lowLevel: [
          {
            question: `Hi there.`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Hi Jackson, how are you?"`,
              `Reply: "Hi Jackson, can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        midLevel: [
          {
            question: `${player.name} how are you, good sir?`,
            relationship: {
              0: { relationshipBump: 1, shouldShow: "good" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "Very good. How are you, Jackson?"`,
              `Reply: "Good! Can I interest you in a free jar of BoBees honey?"`,
            ],
          },
        ],
        highLevel: [
          {
            question: `${player.name} I hope life is treating you well.`,
            relationship: {
              0: { relationshipBump: 2, shouldShow: "flattered" },
              1: { relationshipBump: 0, shouldShow: "sellHoney" },
            },
            replies: [
              `Reply: "It is. I hope you are well, Jackson."`,
              `Reply: "Would you like a free jar of BoBees honey?"`,
            ],
          },
        ],
      },
    },
  };
}
